import React from 'react';

const getFromStorage = (key, defaultValue) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    return defaultValue;
  }
};

export function useLocalStorage(key, defaultValue) {
  const [storedValue, setStoredValue] = React.useState(() => getFromStorage(key, defaultValue));

  const setValue = React.useCallback(
    (value) => {
      try {
        const currentValue = getFromStorage(key, defaultValue);
        const valueToStore = value instanceof Function ? value(currentValue) : value;
        localStorage.setItem(key, JSON.stringify(valueToStore));
        setStoredValue(valueToStore);
      } catch (error) {
        console.error(error);
        // do nothing
      }
    },
    // eslint-disable-next-line
    [key]
  );

  return [storedValue, setValue];
}
